
import Vue from "vue";
import store from "@/store";
import router from "@/router";
import { validationMixin } from "vuelidate";
import AppLoading from "@/components/UI/AppLoading.vue";
import { required, minLength, minValue } from "vuelidate/lib/validators";

export default Vue.extend({
  name: "AdminAddProduct",
  mixins: [validationMixin],
  components: { AppLoading },
  data() {
    return {
      chosenFile: "" as string | FormData,
      chosenFiles: "" as string | FormData,
      defaultImage: require("@/assets/img/default-product.jpg"),
    };
  },
  methods: {
    submitContent() {
      // const data = {
      //     title: this.title,
      //     text: this.description,
      //     language: this.language
      // }
      // store.dispatch("admin/submitAboutUsContent", data)
      const data = store.state.admin.landing.contactUs;
      store.dispatch("admin/submitContactUsContent", data);
    },
  },
  computed: {
    languages(): any[] {
      let items: any[] = [
        {
          title: "انگلیسی",
          value: "En",
        },
        {
          title: "فارسی",
          value: "Fa",
        },
        {
          title: "عربی",
          value: "Ar",
        },
      ];
      return items;
    },

    title: {
      get(): string {
        return store.state.admin.landing.contactUs.title;
      },
      set(value: string): void {
        store.dispatch("admin/updateContactUsTitle", value);
      },
    },
    titleError(): string[] {
      const errors: string[] = [];
      if (!this.$v.title?.$dirty) {
        return errors;
      }
      !this.$v.title.required && errors.push("تکمیل این فیلد الزامی است");
      return errors;
    },

    subTitle: {
      get(): string {
        return store.state.admin.landing.contactUs.subTitle;
      },
      set(value: string): void {
        store.dispatch("admin/updateContactUsSubTitle", value);
      },
    },

    subTitleError(): string[] {
      const errors: string[] = [];
      if (!this.$v.subTitle?.$dirty) {
        return errors;
      }
      !this.$v.subTitle.required && errors.push("تکمیل این فیلد الزامی است");
      return errors;
    },
    address: {
      get(): string {
        return store.state.admin.landing.contactUs.address;
      },
      set(value: string): void {
        store.dispatch("admin/updateContactUsAddress", value);
      },
    },

    addressError(): string[] {
      const errors: string[] = [];
      if (!this.$v.address?.$dirty) {
        return errors;
      }
      !this.$v.address.required && errors.push("تکمیل این فیلد الزامی است");
      return errors;
    },
    email: {
      get(): string {
        return store.state.admin.landing.contactUs.email;
      },
      set(value: string): void {
        store.dispatch("admin/updateContactUsEmail", value);
      },
    },

    emailError(): string[] {
      const errors: string[] = [];
      if (!this.$v.email?.$dirty) {
        return errors;
      }
      !this.$v.email.required && errors.push("تکمیل این فیلد الزامی است");
      return errors;
    },
    phone: {
      get(): string {
        return store.state.admin.landing.contactUs.phone;
      },
      set(value: string): void {
        store.dispatch("admin/updateContactUsPhone", value);
      },
    },

    phoneError(): string[] {
      const errors: string[] = [];
      if (!this.$v.phone?.$dirty) {
        return errors;
      }
      !this.$v.phone.required && errors.push("تکمیل این فیلد الزامی است");
      return errors;
    },

    language: {
      get(): string {
        return store.state.admin.landing.contactUs.language;
      },
      set(value: any): void {
        store.dispatch("admin/updateContactUsLanguage", value);
      },
    },
    languageError(): string[] {
      const errors: string[] = [];
      if (!this.$v.language?.$dirty) {
        return errors;
      }
      !this.$v.language.required && errors.push("تکمیل این فیلد الزامی است");
      return errors;
    },

    isLoading(): boolean {
      return store.state.app.loading;
    },
  },
  mounted() {
    const id = this.$route.query.id;
    if (id) {
      store.dispatch("admin/updateProductCategory", id);
    }
  },
  validations: {
    title: {
      required,
    },
    subTitle: {
      required,
    },
    address: {
      required,
    },
    email: {
      required,
    },
    phone: {
      required,
    },
    language: {
      required,
    },
    languageEsoModel: {
      required,
    },
    titleEso: {},
  },

  created() {
    store.dispatch("admin/getContactUsData");
  },
});
